import { render } from "./ProcessApprovalStepListPreview.vue?vue&type=template&id=30235e12&scoped=true"
import script from "./ProcessApprovalStepListPreview.vue?vue&type=script&lang=js"
export * from "./ProcessApprovalStepListPreview.vue?vue&type=script&lang=js"

import "./ProcessApprovalStepListPreview.vue?vue&type=style&index=0&id=30235e12&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30235e12"]])

export default __exports__